/* eslint-disable complexity */
import React, { useState, useEffect } from "react";
import loadable from "@loadable/component";
import DownloadIcon from "./images/download.svg";
import priceFormatter from "../../../utils/helpers/price-formatter";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { sendCustomGaEvents } from "../../../tracking";
import { NUMBER, alternativeClientId } from "../../../constants/app-constants";
import {
    kavachBannerClicked,
    kavachBannerViewed,
    sellerReceiptPageViewed
} from "../post-inspection-diy/tracking";
const PostInspectionDiyAuctionCard = loadable(() => import("../post-inspection-diy-auction-card"));
const PostInspectionDiyDetailedHoldbacksWrapper = loadable(() => import("../post-inspection-diy-detailed-holdbacks"));
const PostInspectionDiyTransactionDetails = loadable(() => import("../post-inspection-diy-transaction-details"));
const DownloadWhatIsNext = loadable(() => import("../download-what-is-next"));

// eslint-disable-next-line max-statements
const PostInspectionDiyPickupCompleted = ({
    inspectionResponse,
    priceBreakup,
    gaId,
    secureToken,
    fetchTokenProcessedDetailsConnect,
    fetchBankOfferCouponsConnect,
    fetchKavachBannerConnect,
    history
}) => {
    const { token, appointmentId, carImage } = inspectionResponse || {};
    const { priceAfterDeductions
    } = priceBreakup || {};
    const sanitizedOfferedPrice = `₹${priceFormatter(priceAfterDeductions)}`;
    const [userRecipt, setUserRecipt] = useState(null);
    const [showTransactionDetails, setShowTransactionDetails] = useState(false);
    const [transactionDetails, setTransactionDetails] = useState({});
    const { transactionList = [], totalTransactionAmount = NUMBER.ZERO} = transactionDetails || {};
    const sanitizedReceivedAmount = `₹${priceFormatter(totalTransactionAmount)}`;
    const [kavachBannerData, setKavachBannerData] = useState(null);
    const { imageUrl: kavachBanner } = kavachBannerData || {};

    // useEffect(() => {
    //     disableScroll(showDetailedHoldbacks || showTransactionDetails, "hidden");
    // }, [showDetailedHoldbacks, showTransactionDetails]);

    useEffect(() => {
        fetchBankOfferCouponsConnect({ clientId: (gaId || alternativeClientId), secureToken });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gaId, secureToken]);

    useEffect(() => {
        if (token) {
            fetchKavachBannerConnect(token).then((res) => {
                setKavachBannerData(res);
                if (res) {
                    sendCustomGaEvents({
                        ...kavachBannerViewed,
                        eventLabel: appointmentId
                    });
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        sendCustomGaEvents({
            ...sellerReceiptPageViewed,
            eventLabel: appointmentId
        });
    }, [appointmentId]);

    useEffect(() => {
        if (token) {
            fetchTokenProcessedDetailsConnect(token).then((response) => {
                if (response && response.length) {
                    const count = response.reduce((prev, {amount}) => prev + amount, NUMBER.ZERO);
                    setTransactionDetails({
                        transactionList: response,
                        totalTransactionAmount: count
                    });
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const handleKavachBannerClick = () => {
        sendCustomGaEvents({
            ...kavachBannerClicked,
            eventLabel: appointmentId
        });
        history.push("/kavach/");
    };

    return (
        <React.Fragment>
            {
                <div styleName={"styles.contentWrapper"}>
                    <div styleName={"styles.congratulationsText"}>
                        <h3>Congratulations! You've successfully sold your car on CARS24</h3>
                    </div>
                    {
                        !!priceAfterDeductions &&
                    <div>
                        <PostInspectionDiyAuctionCard
                            showCarIcon={true}
                            carImage={carImage}
                            heading={"Final in-hand offer"}
                            isSold={true}
                        >
                            {sanitizedOfferedPrice}
                        </PostInspectionDiyAuctionCard>
                    </div>
                    }
                    <PostInspectionDiyDetailedHoldbacksWrapper/>
                    {
                        userRecipt &&
                            <a
                                styleName={"styles.downloadsReceiptText"}
                                target="_blank"
                                download="Receipt.pdf"
                                href={userRecipt}
                            >
                                <img src={DownloadIcon} alt="download_receipt" />
                                Download receipt
                            </a>
                    }

                    {
                        !!kavachBanner &&
                        <img
                            styleName="styles.kavachBannerWrapper"
                            src={kavachBanner}
                            alt="kavach_banner"
                            onClick={handleKavachBannerClick}
                        />
                    }

                    <DownloadWhatIsNext
                        setUserRecipt={setUserRecipt}
                    />
                    {
                        showTransactionDetails && transactionList && !!transactionList.length &&
                            <PostInspectionDiyTransactionDetails
                                sanitizedReceivedAmount={sanitizedReceivedAmount}
                                transactionList={transactionList}
                                onClose={() => {setShowTransactionDetails(false);}}
                            />
                    }
                </div>
            }
        </React.Fragment>
    );
};

PostInspectionDiyPickupCompleted.propTypes = {
    inspectionResponse: PropTypes.object,
    priceBreakup: PropTypes.object,
    gaId: PropTypes.string,
    secureToken: PropTypes.string,
    fetchTokenProcessedDetailsConnect: PropTypes.func,
    fetchBankOfferCouponsConnect: PropTypes.func,
    setActiveTabConnect: PropTypes.func,
    activeTab: PropTypes.string,
    fetchKavachBannerConnect: PropTypes.func,
    history: PropTypes.object
};

export default PostInspectionDiyPickupCompleted;
